<template>
  <v-container fluid>
    <PageHeaderSlot />

    <Datatable
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :page.sync="tableFilter.page"
      :pageLimit.sync="tableFilter.limit"
      :itemTotal="tableItemTotal"
      @options-update="getEnquiryData()"
    />
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'

export default {
  name: 'Enquiry',
  components: {
    Datatable,
  },
  data: vm => ({
    tableLoading: false,
    tableData: [],
    tableItemTotal: 0,
    tableFilter: {
      page: 1,
      limit: 10,
    },
    tableHeaders: [
      { value: 'create_date', text: vm.$t('createdDate'), width: 130 },
      { value: 'call', text: vm.$t('call'), width: 150 },
      { value: 'grade', text: vm.$t('grade'), width: 130 },
      { value: 'phone', text: vm.$t('phone'), width: 180 },
      { value: 'content', text: vm.$t('content') }
    ],
  }),
  methods: {
    async getEnquiryData(regenUrl = true) {
      if (regenUrl === true) {
        this._regenerateURL()
      }
      this.tableLoading = true

      try {
        let payload = {
          filter_limit: this.tableFilter.limit,
          filter_page: this.tableFilter.page - 1,
        }

        const { data, total } = await this.$Fetcher.GetEnquiries(payload)
        this.tableData = data.map(el => {
            return {
                ...el,
                create_date: `${el.create_date.substring(0, 10)} ${el.create_date.substring(11, 16)}`,
                grade: el.year
            }
        })
        this.tableItemTotal = total
      } catch (err) {
        this.tableData = []
        if (this.tableFilter.page === 1) {
          this.tableItemTotal = 0
        }
      } finally {
        this.tableLoading = false
      }
    },

    _getQuery() {
      this.tableFilter.page = 1
      this.tableFilter.limit = 10
      const query = this.gfGetTableQuery({
        page: 'int',
        limit: 'int',
      })
      for (const key in this.tableFilter) {
        if (this.$validate.DataValid(query[key])) {
          this.$set(this.tableFilter, key, query[key])
        }
      }
    },
    _regenerateURL() {
      let q = {
        page: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.page : null,
        limit: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.limit : null,
      }
      const newQuery = this.$common.diffQuery(q, this.$route.query)
      if (newQuery) this.$router.replace({ query: newQuery })
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: Enquiry')
      this._getQuery()
      this.$store.dispatch('toggleLoadingPage', false)

      await this.getEnquiryData(false)
    },
  },
  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.tableLoading = true
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    this.$XHR.abort()
    next()
  },
}
</script>
